import React from 'react';
import PropTypes from 'prop-types';

import { Scope } from 'informed';
import { get } from 'lodash-es';

import HiddenField from '../../Common/HiddenField';
import BillingFields from './BillingFields';
import CoveredSummary from './CoveredSummary';
import SubscriberFields from './SubscriberFields';

const Subscription = ({
  index,
  readOnly,
  subscriptionItem,
  strings,
  config,
  data,
  formApi,
  formState,
  defaultValues,
}) => {
  const { covered } = subscriptionItem;
  const subscriber = get(subscriptionItem, 'subscriber', covered);
  const subscriberTitle = get(strings, 'block.transform.subscriber.title', 'Adhérent');
  const billingTitle = get(strings, 'block.transform.billing.title', 'Quittancement');
  const subscriberKind = get(data, 'subscriber_kind');

  return (
    <Scope scope={`subscriptions[${index}]`}>
      <HiddenField field="covered" initialValue={index} />
      <div className="subscription">
        <div className="title--block">
          {subscriberTitle}
          <CoveredSummary strings={strings} index={index} covered={covered} />
        </div>
        <div className="page subscriber">
          <SubscriberFields
            index={index}
            subscriber={subscriber}
            subscriptionItem={subscriptionItem}
            strings={strings}
            readOnly={readOnly}
            formState={formState}
            config={config}
            subscriberKind={subscriberKind}
          />
        </div>
        <div className="page billing">
          <div className="title--sub-block">{billingTitle}</div>
          <BillingFields
            billingModes={get(data, 'billingModes')}
            config={config}
            values={get(subscriptionItem, 'subscriber')}
            strings={strings}
            banks={get(config, 'config.covered.banks', [])}
            readOnly={readOnly}
            formApi={formApi}
            index={index}
            defaultValues={defaultValues}
          />
        </div>
      </div>
    </Scope>
  );
};

Subscription.propTypes = {
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  formState: PropTypes.any.isRequired, // eslint-disable-line
  data: PropTypes.any.isRequired, // eslint-disable-line
  index: PropTypes.number.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  readOnly: PropTypes.bool.isRequired,
  subscriptionItem: PropTypes.shape({
    covered: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    subscriber: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  }).isRequired,
  config: PropTypes.any.isRequired, // eslint-disable-line
  defaultValues: PropTypes.object, // eslint-disable-line
};

Subscription.defaultProps = {
  strings: {},
  defaultValues: undefined,
};

export default Subscription;
